let products
let prices
let measure
let timebased
let form
let fixed = 0
let tarif = 1

const weraInit = () => {
  const input = document.querySelectorAll("input")
  input.forEach(element => {
    if (element.name === 'selectedTarification') {
      element.addEventListener('change', showHandler)
    } else if (element.name === 'selectedPriceType') {
      element.addEventListener('change', showHandler)
    } else if (element.name === 'selectedProductId') {
      element.addEventListener('change', productHandler)
    }
  })
  products = document.querySelectorAll('[data-product]')
  prices = document.querySelectorAll('[data-tarif]')
  measure = document.querySelectorAll('[data-onlytarif]')
  timebased = document.querySelectorAll('[data-onlyfixed]')
  form = document.querySelector('#productForm')
  if (form) {
    if (form.selectedTarification.value < 1) {
      form.selectedTarification.value = '1'
    }
    if (form.selectedPriceType.value < 1) {
      form.selectedPriceType.value = '0'
    }
    tarif = form.selectedTarification.value
    fixed = form.selectedPriceType.value
    showProducts()
    showPrices()
    setPriceList()
  }
}

const showHandler = () => {
  tarif = form.selectedTarification.value
  fixed = form.selectedPriceType.value
  showProducts()
  showPrices()
  setPriceList()
}
const productHandler = () => {
  setPriceList()
}

const setPriceList = () => {
  const element = document.querySelector('#product_' + form.selectedProductId.value)
  if (element) {
    form.selectedPriceListId.value = (fixed === '1')?element.dataset.pricelist1:element.dataset.pricelist0
  }
  if (form.selectedPriceListId.value === 'undefined') {
    form.selectedPriceListId.value = '0'
  }
  document.querySelector('#form_submit').disabled = !(form.selectedPriceListId.value && form.selectedProductId.value);
}

const showPrices = () => {
  prices.forEach(item => {
    if (item.dataset.tarif === tarif && item.dataset.fixed === fixed) {
      item.classList.remove('hidden')
    } else {
      item.classList.add('hidden')
    }
  })
  measure.forEach(item => {
    if (item.dataset.onlytarif === tarif) {
      item.classList.remove('hidden')
    } else {
      item.classList.add('hidden')
    }
  })
  timebased.forEach(item => {
    if (item.dataset.onlyfixed === fixed) {
      item.classList.remove('hidden')
    } else {
      item.classList.add('hidden')
    }
  })
}

const showProducts = () => {
  products.forEach(product => {
    const showFixed = product.dataset.showfixed.split(',')
    const showTarif = product.dataset.showtarif.split(',')
    if (showFixed.includes(fixed) && showTarif.includes(tarif)) {
      product.classList.remove('hidden')
    } else {
      product.classList.add('hidden')
    }
  });
}

window.addEventListener('load', weraInit)

